import theme from 'styled-theming';

export const appearanceCacheKey = 'appearance';

export enum Appearance {
  Normal = 'www',
  Dark = 'dark',
  Gray = 'gray',
}

export const colorPalette: any = {
  // gray scale
  black: {
    www: '#333333',
    gray: '#222222',
    dark: '#e6e6e6',
  },
  gray01: {
    www: '#616161',
    gray: '#616161',
    dark: '#b8b8b8',
  },
  gray02: {
    www: '#939393',
    gray: '#939393',
    dark: '#a3a3a3',
  },
  gray03: {
    www: '#c4c4c4',
    gray: '#cccccc',
    dark: '#8a8a8a',
  },
  gray04: {
    www: '#e4e4e4',
    // gray: '#e4e4e4',
    gray: '#E5E4DE',
    dark: '#383838',
  },
  gray05: {
    www: '#eeeeee',
    gray: '#eeeeee',
    dark: '#2e2e2e',
  },
  gray06: {
    www: '#f6f6f6',
    gray: '#f6f6f6',
    dark: '#262626',
  },
  gray07: {
    www: '#fafafa',
    dark: '#212121',
  },
  blue01: {
    www: '#D8E7FF',
    gray: '#D8E7FF',
    dark: '#2d2d2d',
  },
  blue02: {
    www: '#F6FAFF',
    gray: '#F6FAFF',
    dark: '#080808',
  },
  blue03: {
    www: '#EFF6FF',
    gray: '#EFF6FF',
    dark: '#212C3B',
  },
  white: {
    www: '#ffffff',
    gray: '#ffffff',
    dark: '#121212',
  },
  background: {
    www: '#ffffff',
    gray: '#f1eeea',
    dark: '#121212',
  },
  paper: {
    www: '#ffffff',
    gray: '#ffffff',
    dark: '#262626',
  },
  whiteFix: {
    www: '#ffffff',
    gray: '#ffffff',
    dark: '#ffffff',
  },
  blackFix: {
    www: '#333333',
    gray: '#333333',
    dark: '#333333',
  },

  // calendar
  saturday: {
    www: '#1a67ae',
    gray: '#1a67ae',
    dark: '#6699cc',
  },
  holiday: {
    www: '#ce1f1f',
    gray: '#ce1f1f',
    dark: '#ff6666',
  },

  // External Services
  primary: {
    www: '#1f74f2',
    gray: '#222222',
    dark: '#2776ec',
  },
  primaryVariantDark: {
    www: '#0066FF',
    gray: '#222222',
    dark: '#0066FF',
  },
  primaryVariantLight: {
    www: '#E8F6FB',
    gray: '#222222',
    dark: '#E8F6FB',
  },
  secondary: {
    www: '#E91E63',
    gray: '#222222',
    dark: '#D3346A',
  },
  secondaryVariantDark: {
    www: '#F21463',
    gray: '#F21463',
    dark: '#F21463',
  },
  secondaryVariantLight: {
    www: '#EAF8E9',
    gray: '#EAF8E9',
    dark: '#EAF8E9',
  },
  attention: {
    www: '#DD0000',
    gray: '#DD0000',
    dark: '#DD0000',
  },
  success: {
    www: '#60DF52',
    gray: '#60DF52',
    dark: '#60DF52',
  },
  error: {
    www: '#E95175',
    gray: '#E95175',
    dark: '#E95175',
  },
  errorBackground: {
    www: '#FFEFF5',
    gray: '#FFEFF5',
    dark: '#FFEFF5',
  },
  disabled: {
    www: '#e4e4e4',
    gray: '#e4e4e4',
    dark: '#e4e4e4',
  },
  stripeBackgroud: {
    www: '#F3F3FD',
    gray: '#F3F3FD',
    dark: '#1e1f1f',
  },
  guest: {
    www: '#FF9900',
    gray: '#FF9900',
    dark: '#F99806',
  },
  guestPaletone: {
    www: '#FFF5DD',
    gray: '#FFF5DD',
    dark: '#342D1D',
  },
  blueGrayPale: {
    www: '#F7F9FC',
    gray: '#F7F9FC',
    dark: '#1e1f1f',
  },
  secondaryPale: {
    www: '#FCF7F9',
    gray: '#FCF7F9',
    dark: '#201D1E',
  },
  socialButtonLabel: {
    www: '#0000008a',
  },
};

function getPallet(name: string) {
  if (!colorPalette[name]) {
    console.error(`Failed to get color [${name}]`);
    return '';
  }
  return colorPalette[name];
}

export function serviceTheme(name: string, props: any) {
  const color = getPallet(name);
  return theme('appearance', color)(props);
}

export const serviceVariantColors = [
  '#56E2C0',
  '#4CD1E5',
  '#5656E2',
  '#9C56E2',
  '#E25685',
  '#E35656',
  '#F28D44',
  '#F5D849',
  '#B9E344',
  '#63DB6D',
];
export const randomCalendarColor = () => {
  const max = serviceVariantColors.length;
  const random = Math.floor(Math.random() * max);
  return serviceVariantColors[random % max];
};
export const getCalendarColorById = (id: string): string => {
  // 基本あると思うがidが取れなかった場合は、最初の色を返す
  if (!id) {
    return serviceVariantColors[0];
  }
  const max = serviceVariantColors.length;
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash += id.charCodeAt(i);
  }
  return serviceVariantColors[hash % max];
};

export const statBarVariantColors = [
  '#1F74F2',
  '#79ABF7',
  '#A6C7FA',
  '#D2E3FC',
];

export const black = (props: any) => serviceTheme('black', props);
export const paper = (props: any) => serviceTheme('paper', props);
export const gray01 = (props: any) => serviceTheme('gray01', props);
export const gray02 = (props: any) => serviceTheme('gray02', props);
export const gray03 = (props: any) => serviceTheme('gray03', props);
export const gray04 = (props: any) => serviceTheme('gray04', props);
export const gray05 = (props: any) => serviceTheme('gray05', props);
export const gray06 = (props: any) => serviceTheme('gray06', props);
export const gray07 = (props: any) => serviceTheme('gray07', props);
export const blue01 = (props: any) => serviceTheme('blue01', props);
export const blue02 = (props: any) => serviceTheme('blue02', props);
export const blue03 = (props: any) => serviceTheme('blue03', props);
export const white = (props: any) => serviceTheme('white', props);
export const whiteFix = (props: any) => serviceTheme('whiteFix', props);
export const blackFix = (props: any) => serviceTheme('blackFix', props);
export const saturday = (props: any) => serviceTheme('saturday', props);
export const holiday = (props: any) => serviceTheme('holiday', props);
export const primary = (props: any) => serviceTheme('primary', props);
export const primaryVariantDark = (props: any) =>
  serviceTheme('primaryVariantDark', props);
export const primaryVariantLight = (props: any) =>
  serviceTheme('primaryVariantLight', props);
export const secondary = (props: any) => serviceTheme('secondary', props);
export const secondaryVariantDark = (props: any) =>
  serviceTheme('secondaryVariantDark', props);
export const secondaryVariantLight = (props: any) =>
  serviceTheme('secondaryVariantLight', props);
export const success = (props: any) => serviceTheme('success', props);
export const error = (props: any) => serviceTheme('error', props);
export const background = (props: any) => serviceTheme('background', props);
export const errorBackground = (props: any) =>
  serviceTheme('errorBackground', props);
export const attention = (props: any) => serviceTheme('attention', props);
export const stripeBackgroud = (props: any) =>
  serviceTheme('stripeBackgroud', props);
export const guest = (props: any) => serviceTheme('guest', props);
export const guestPaletone = (props: any) =>
  serviceTheme('guestPaletone', props);
export const blueGrayPale = (props: any) => serviceTheme('blueGrayPale', props);
export const secondaryPale = (props: any) =>
  serviceTheme('secondaryPale', props);
export const socialButtonLabel = (props: any) =>
  serviceTheme('socialButtonLabel', props);
